<template>
	<div>
    <van-cell-group>
      <van-field
        v-model="message"
        rows="6"
        label=""
        type="textarea"
        minlength="15"
        maxlength="100"
        placeholder="编辑自我介绍，展示更好的自己（15-100个字）"
        show-word-limit
      />
    </van-cell-group>
    <footer>
      <button class="btn" :class="{'gray': message.length < 15}" @click="submit">保存</button>
    </footer>
  </div>
</template>

<script>
  import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
  import wx from 'weixin-js-sdk'
	export default {
		name: "updateintroduce",
    data () {
		  return {
        message: ''
      }
    },
    mounted: function () {
		  if (isWeixin()) fenxiang({path: 'updateintroduce'})
      var arg = isApp()
      if (arg != '') {
        this.getData()
      } else {
        if (this.$store.state.updateIntroduce) this.message = this.$store.state.updateIntroduce
      }
    },
    methods: {
		  getData: function () {
		    var url = this.$ajax.getMain_URL
        this.$customRequestAjax(url).then(res => {
          if (res.data.code == 200 && res.data.data.selfintroduction) {
            this.message = res.data.data.selfintroduction
          }
        })
      },
      submit () {
        if (this.$route.query.verstatus == 0 && this.message.trim() != '' && this.message.trim().length < 15) {
          this.$toast('请输入自我介绍且大于15个字')
          return
        } else if (this.$route.query.verstatus != 0 && this.message.trim().length < 15) {
          this.$toast('请输入自我介绍且大于15个字')
          return
        }
        this.message = this.message.trim().replace(/\r\n/g, ' ')
        var url = this.$ajax.updateMainInfo_URL, data = {
          content: this.message
        }
        this.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code == 200) {
            var arg = isApp()
            this.$toast(res.data.msg)
            if (arg == '') {
              this.$store.commit('UPDATE_INTRODUCE', this.message)
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else if (arg.indexOf('xcx') >= 0) {
              wx.miniProgram.navigateBack()
            }
          }
        })
      }
    }
	}
</script>

<style scoped lang="scss">
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.63rem;
    padding: 0.1rem 0.11rem;
    background: #ffffff;
    .btn {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color: #ffffff;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, #fc0324, #f63a66);
      background: -webkit-linear-gradient(90deg, #fc0324, #f63a66);
      background: -o-linear-gradient(90deg, #fc0324, #f63a66);
      background: -moz-linear-gradient(90deg, #fc0324, #f63a66);
      background: -ms-linear-gradient(90deg, #fc0324, #f63a66);
      &.gray {
        background: #e3e3e3;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/updateintroduce.vue